import { Form, Input, Select } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { BudgetRequest } from 'src/pages/budget/budgetRequests/types'
import { PRODUCT_OPTIONS, STATUS_OPTIONS } from 'src/pages/budget/const'
import {
  filterOption,
  getOptionsForArticles,
  getOptionsForCreatedBy,
} from 'src/pages/budget/utils'
import { TStatus } from 'src/pages/budget/types'

type FilterField =
  | 'articleName'
  | 'createdBy'
  | 'status'
  | 'products'
  | 'searchText'

type Props = {
  list: BudgetRequest[]
  fields: FilterField[]
  optionsStatus?: TStatus[]
  onChange: (values: Record<string, any>) => void
  initialValues?: Partial<Record<FilterField, any>>
}

export const FilterTable = ({
  list,
  fields,
  optionsStatus,
  onChange,
  initialValues,
}: Props) => {
  const { Item } = Form
  const [form] = Form.useForm()

  const currentOptionsStatus = optionsStatus
    ? STATUS_OPTIONS.filter(({ value }) => optionsStatus.includes(value))
    : STATUS_OPTIONS

  const filterConfig = {
    articleName: () => {
      const options = getOptionsForArticles(list)
      return (
        <Item
          name="articleName"
          key="articleName"
          style={{ minWidth: 150, maxWidth: 170 }}
        >
          <Select
            placeholder="Статья"
            mode="multiple"
            options={options}
            filterOption={filterOption}
          />
        </Item>
      )
    },

    createdBy: () => {
      const options = getOptionsForCreatedBy(list)
      return (
        <Item
          name="createdBy"
          key="createdBy"
          style={{ minWidth: 150, maxWidth: 200 }}
        >
          <Select placeholder="Заявитель" mode="multiple" options={options} />
        </Item>
      )
    },

    status: () => {
      return (
        <Item
          name="status"
          key="status"
          style={{ minWidth: 170, maxWidth: 200 }}
        >
          <Select
            placeholder="Статус"
            mode="tags"
            options={currentOptionsStatus}
          />
        </Item>
      )
    },

    products: () => {
      return (
        <Item
          name="products"
          key="products"
          style={{ minWidth: 150, maxWidth: 180 }}
        >
          <Select placeholder="Продукт" mode="tags" options={PRODUCT_OPTIONS} />
        </Item>
      )
    },

    searchText: () => {
      return (
        <Item
          name="searchText"
          key="searchText"
          style={{ minWidth: 150, maxWidth: 250 }}
        >
          <Input
            placeholder="Search"
            prefix={
              <SearchOutlined
                style={{ color: 'var(--color-gray-60)', fontSize: 12 }}
              />
            }
          />
        </Item>
      )
    },
  }

  return (
    <Form
      form={form}
      layout="inline"
      onValuesChange={(_, allValues) => onChange?.(allValues)}
      initialValues={initialValues}
      style={{
        marginRight: '-1em',
        display: 'flex',
        flexWrap: 'wrap',
        rowGap: 8,
      }}
    >
      {fields.map((field) => filterConfig[field]())}
    </Form>
  )
}
